<!-- desktop -->
<div class="menu-bg mob-none">
    <div class="logo-container">
        <div class="logo clickable" (click)="navigateToDashboard()">
            <img alt="logoWhite" src="{{assetsUrl}}LogoWhite.png">
            <div class="logo-divider"></div>
        </div>
        <div class="subtext">Portal Manager</div>
    </div>
    <div>

        <div class="p-d-flex logoutSection p-jc-end">

            <div class="logo-divider"></div>

            <div class="welcome-greetings p-my-auto">
                <span >Welcome {{displayName}}</span>
                <span *ngIf="isSuperAdminUser"><span class="p-mx-2">|</span>Superadmin </span>
                <div class="timeout">{{time}}</div>
            </div>
            
        </div>
        

    </div>

</div>

<!-- mobile header -->
<div class="mob-block">

    <p-sidebar [(visible)]="display" [fullScreen]="true" position="top" [baseZIndex]="10000" class="sidebar-menu">
        <div class="mb-menu-bg logoutSection">
            <div class="p-mr-2 letterSpacing">
                Welcome {{displayName}} <span *ngIf="isSuperAdminUser"> | Superadmin</span>
            </div>
            <div class="timeout">{{time}}</div>
            <div>
                <div class="manage-user" *ngIf="(isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch)) && !url.includes('team-website') && searchAgentInfoForHeader">Now Managing:  {{searchAgentInfoForHeader?.agentName}}</div>
            <div class="manage-user" *ngIf="(isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch) || url.includes('team-website')) && url.includes('team-website') && searchAgentInfoForHeader">Now Managing:  {{searchAgentInfoForHeader?.agentName}}, {{teamName}}</div>
            </div>
            <div style="clear: both;"></div>
        </div>
        <div *ngIf="(!isLOBUser && ((isSuperAdminUser || isBranchAdminUser) && searchAgentInfoForHeader) || isOfficeManagerUser || isAgentUser) && display">
            <div class="mobile-menu-wrapper" [ngClass]="{'nowmanaging':((isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch) || url.includes('team-website')) && url.includes('team-website') && searchAgentInfoForHeader) ||((isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch)) && !url.includes('team-website') && searchAgentInfoForHeader)}">
                <app-menu (closeSidebarHeader)="closeSideBarHeader($event)" [officeManagerAgentSearch]="officeManagerAgentSearch" [isSearchedOfficeManagerUser]="isSearchedOfficeManagerUser"></app-menu>
            </div>
            <div class="mobile-sub-menu-wrapper" [ngClass]="{'nowmanaging':((isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch) || url.includes('team-website')) && url.includes('team-website') && searchAgentInfoForHeader) ||((isSuperAdminUser || isBranchAdminUser || (isOfficeManagerUser && officeManagerAgentSearch)) && !url.includes('team-website') && searchAgentInfoForHeader) }">
                <app-personal-info-sub-menu *ngIf="isPersonalInfoEnabled" (closeSidebarHeader)="closeSideBarHeader($event)"></app-personal-info-sub-menu>
                <app-subscription-sub-menu *ngIf="isSubscriptionEnabled" (closeSidebarHeader)="closeSideBarHeader($event)"></app-subscription-sub-menu>
                <app-team-website-sub-menu *ngIf="isTeamWebsiteEnabled && checkTeamRole()" (closeSidebarHeader)="closeSideBarHeader($event)"></app-team-website-sub-menu>
                <app-office-website-sub-menu *ngIf="isOfficeWebsiteEnabled" (closeSidebarHeader)="closeSideBarHeader($event)"></app-office-website-sub-menu>               
                <app-leads-crm-sub-menu *ngIf="isLeadsEnabled" (closeSidebarHeader)="closeSideBarHeader($event)"></app-leads-crm-sub-menu>
            </div>
        </div>
        <app-smart-menu *ngIf="isSuperAdminUser || isBranchAdminUser || officeManagerAgentSearch" (onPortalEmit)="onPortalClick($event)" (onCoreEmit)="onCoreClick($event)"   (closeHeaderPopup)="display = false;" (onHomeEmit)="closeHeader()" (onListClickEmit)="onListSearch($event)"></app-smart-menu>
    </p-sidebar>


    <div class="menu-bg">
        <div class="logo-container">
            <div class="logo clickable" (click)="navigateToDashboard()">
                <img alt="logoWhite" src="{{assetsUrl}}LogoWhite.png">
                <div class="logo-divider"></div>
            </div>
            <div class="subtext">Portal Manager</div>
        </div>
        <button label="menu" class="p-jc-end menu-icon" (click)="display = true" >
            <img alt="Humbuger-Icon" src="{{assetsUrl}}Humbuger-Icon.png">
        </button>
    </div>
</div> 
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="redirectToLandingPage()"
  #headerClickConfirmation
>
</app-search-update-confirmation>